// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-margin {\n  margin: 0 0 5px 5px;\n}\n.dealings-check-accounts-view2-multi-currency .el-form-item-search .el-form-item__content .el-radio {\n  margin-right: 5px;\n}\n.dealings-check-accounts-view2-multi-currency .el-form-item-search .el-form-item__content .el-radio .el-radio__label {\n    font-size: 12px !important;\n    padding-left: 2px;\n}\n", ""]);
// Exports
module.exports = exports;
